export enum ObjectTypeInfoColumnDataType {
  Boolean = 'Boolean',
  Date = 'Date',
  Float = 'Float',
  Integer = 'Integer',
  VarBinary = 'VarBinary',
  Text = 'Text',
  Varchar = 'Varchar',
  Time = 'Time',
  Currency = 'Currency',
  GUID = 'GUID',
  TimeSpan = 'TimeSpan',
  Geometry = 'Geometry',
}

export enum ObjectTypeInfoColumnType {
  PrimaryKey = 'PrimaryKey',
  ObjectType = 'ObjectType',
  Sys = 'Sys',
  IdRef = 'IdRef',
  Picklist = 'Picklist',
}

export class ObjectTypeInfoBase {
  Name: string;
  DisplayText: string;
}

export class ObjectTypeInfo extends ObjectTypeInfoBase {
  Namespace: string;
  DisplayTextPlural: string;
  UniqueDisplayText: string;
  BaseTypeName: string;
  Columns: ObjectTypeInfoColumn[];
  References: ObjectTypeInfoReference[];
  Referencing: ObjectTypeInfoReferencing[];
  Value: string;

  constructor(data: any) {
    super();
    Object.assign(this, data);

    this.Columns = new Array<ObjectTypeInfoColumn>();
    this.References = new Array<ObjectTypeInfoReference>();
    this.Referencing = new Array<ObjectTypeInfoReferencing>();

    if (data.Columns) {
      for (let column of data.Columns) {
        this.Columns.push(new ObjectTypeInfoColumn(column));
      }
    }

    if (data.References) {
      for (let ref of data.References) {
        this.References.push(new ObjectTypeInfoReference(ref));
      }
    }

    if (data.Referencing) {
      for (let ref of data.Referencing) {
        this.Referencing.push(new ObjectTypeInfoReferencing(ref));
      }
    }
  }
}

export class ObjectTypeInfoColumn extends ObjectTypeInfoBase {
  DataType: ObjectTypeInfoColumnDataType;
  IsRequired?: boolean;
  ColumnType?: ObjectTypeInfoColumnType;
  NameInBaseType?: string;

  constructor(data: any) {
    super();
    Object.assign(this, data);
  }
}

export class ObjectTypeInfoReference extends ObjectTypeInfoBase {
  ReferencingColumn: string;
  ReferencingObjectTypeColumn: string;
  ReferencedObjectTypeName: string;

  constructor(data: any) {
    super();
    Object.assign(this, data);
  }
}

export class ObjectTypeInfoReferencing extends ObjectTypeInfoBase {
  ReferencingColumn: string;
  ReferencingObjectTypeName: string;

  constructor(data: any) {
    super();
    Object.assign(this, data);
  }
}
